import { j as s } from "./kezios-design-system.esm172.js";
import { Card as x } from "@mantine/core";
import { Spacing as r } from "./kezios-design-system.esm135.js";
const i = ({ children: p, ...o }) => /* @__PURE__ */ s.jsx(
  x,
  {
    radius: 2e3,
    px: r.s10,
    py: r.s5,
    shadow: "-11px 11px 50px 0px rgba(0, 0, 0, 0.10)",
    ...o,
    children: p
  }
);
export {
  i as BadgeCard
};
